import React, { useState } from 'react'
import { ConditionalWrapper } from '../../utils'
import { IFeatures } from '../types'
import { IProductFeatures } from '../types'
import ParrotfishIcon from '../../ParrotfishIcon'
import RichText from '../../RichText'

// MUI
import { useTheme } from '@mui/material/styles'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Popover from '@mui/material/Popover'
import Tooltip from '@mui/material/Tooltip'

const ProductFeature = ({ features, isStacked }: IProductFeatures) => {
  // const classes = useStyles({ isStacked })
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [elementId, setElementId] = useState<number | null>(null)
  const handleClose = () => {
    setAnchorEl(null)
    setElementId(null)
  }
  const handleClick = (event: React.MouseEvent<HTMLElement>, id: number) => {
    setAnchorEl(event.currentTarget)
    setElementId(id)
  }
  const { palette, breakpoints, shape, typography } = useTheme()

  const styles = {
    root: {
      padding: `0 0 10px 0`,
      alignItems: 'flex-start',

      '&:last-child': {
        paddingBottom: '0px',
      },

      '& .MuiListItemIcon-root': {
        minWidth: 'unset',
        marginTop: '5px',
        marginRight: '12px',
      },
    },
    icon: {
      color: palette.success.main,
      width: 16,
      height: 16,
    },
    listItemText: {
      '& .MuiTypography-displayBlock': {
        ...typography.body2,
      },
    },
    toolsd: {
      border: '2px solid red',
      textDecoration: 'underline',
    },
    tooltip: {
      // '& .MuiTypography-displayBlock': {
      textDecoration: 'underline',
      '& span': {
        fontSize: '0.875rem !important',
      },

      // },
    },
    isClickable: {
      cursor: 'pointer',
    },
    productCardContentFeatureList: {
      padding: '0px',
      margin: '0px',
      display: isStacked === false ? 'grid' : null,
      gridTemplateColumns: `repeat(3, auto)`,
      gridColumnGap: 16,

      [breakpoints.down('sm')]: {
        gridTemplateColumns: `repeat(1, auto)`,
      },
    },
  }

  return (
    <List sx={styles.productCardContentFeatureList}>
      {features.map((feature: IFeatures, index: number) => (
        <ListItem key={index} sx={styles.root}>
          {feature.icon && (
            <ListItemIcon>
              <ParrotfishIcon iconImage={feature.icon.iconImage} sx={styles.icon} />
            </ListItemIcon>
          )}
          <ConditionalWrapper
            condition={!!feature.tooltip}
            wrapper={children => (
              <>
                <Tooltip placement={'bottom-start'} title={feature.tooltip} sx={styles.tooltip}>
                  {children}
                </Tooltip>
                {feature && feature?.popover && (
                  <Popover
                    open={index === elementId}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    <RichText {...feature.popover} />
                  </Popover>
                )}
              </>
            )}
          >
            <ListItemText
              sx={{
                ...(feature.popover && { cursor: 'pointer', textDecoration: 'underline' }),
                '& span': {
                  fontSize: '0.875rem',
                },
                ...styles.listItemText,
              }}
              primary={feature.content?.content ? feature.content?.content : 'Empty content field'}
              onClick={event => handleClick(event, index)}
            />
          </ConditionalWrapper>
        </ListItem>
      ))}
    </List>
  )
}

export default ProductFeature
